/**
 * Code-split public routes — not loaded on initial `/` visit.
 * Funnel/checkout/membership entry pages stay eagerly imported in App.tsx.
 */
import { lazy, Suspense, type ComponentType } from "react";
import { TemplateLoadingScreen } from "@/components/templates/TemplateLoadingScreen";
import { lazyPage } from "@/lib/lazyPage";

export const Argentina = lazyPage(() => import("./Argentina"));
export const InvitacionExclusivaArgentina = lazyPage(() => import("./InvitacionExclusivaArgentina"));
export const InvitacionArSuccess = lazyPage(() => import("./InvitacionArSuccess"));
export const InvitacionArError = lazyPage(() => import("./InvitacionArError"));
export const InvitacionArPending = lazyPage(() => import("./InvitacionArPending"));
export const PremiumInvite = lazyPage(() => import("./PremiumInvite"));
export const MembresiaPremiumVip = lazyPage(() => import("./MembresiaPremiumVip"));
export const TestNewTemplate = lazyPage(() => import("./TestNewTemplate"));
export const TestPremiumArgentina = lazyPage(() => import("./TestPremiumArgentina"));
export const TestPremiumInternacional = lazyPage(() => import("./TestPremiumInternacional"));
export const Artista = lazyPage(() => import("./Artista"));
export const Atleta = lazyPage(() => import("./Atleta"));
export const BeautyExpert = lazyPage(() => import("./BeautyExpert"));
export const Belleza = lazyPage(() => import("./Belleza"));
export const Biografia = lazyPage(() => import("./Biografia"));
export const BuenosAires = lazyPage(() => import("./BuenosAires"));
export const Contenido = lazyPage(() => import("./Contenido"));
export const ContentCreator = lazyPage(() => import("./ContentCreator"));
export const EnglishHome = lazyPage(() => import("./EnglishHome"));
export const CreadoraContenido = lazyPage(() => import("./CreadoraContenido"));
export const Creative = lazyPage(() => import("./Creative"));
export const Deportista = lazyPage(() => import("./Deportista"));
export const Desnuda = lazyPage(() => import("./Desnuda"));
export const DigitalCreator = lazyPage(() => import("./DigitalCreator"));
export const Entrenamiento = lazyPage(() => import("./Entrenamiento"));
export const Erome = lazyPage(() => import("./Erome"));
export const Exclusivo = lazyPage(() => import("./Exclusivo"));
export const ExclusivoArSuccess = lazyPage(() => import("./ExclusivoArSuccess"));
export const Fashion = lazyPage(() => import("./Fashion"));
export const FullscreenExclusiveAr = lazyPage(() => import("./FullscreenExclusiveAr"));
export const Filtrado = lazyPage(() => import("./Filtrados"));
export const Filtro = lazyPage(() => import("./Filtro"));
export const Fitness = lazyPage(() => import("./Fitness"));
export const Fotos = lazyPage(() => import("./Fotos"));
export const FotosDesnuda = lazyPage(() => import("./FotosDesnuda"));
export const FotosGratis = lazyPage(() => import("./FotosGratis"));
export const Galeria = lazyPage(() => import("./Galería"));
export const Gratis = lazyPage(() => import("./Gratis"));
export const Imagenes = lazyPage(() => import("./Imagenes"));
export const IndexMinimal = lazyPage(() => import("./IndexMinimal"));
export const Influencer = lazyPage(() => import("./Influencer"));
export const Instagram = lazyPage(() => import("./Instagram"));
export const Invitacion = lazyPage(() => import("./Invitacion"));
export const InvitacionGrupo = lazyPage(() => import("./InvitacionGrupo"));
export const Invite = lazyPage(() => import("./Invite"));
export const InviteGenerator = lazyPage(() => import("./InviteGenerator"));
export const Leaked = lazyPage(() => import("./Leaked"));
export const Lifestyle = lazyPage(() => import("./Lifestyle"));
export const MembresiaTelegram = lazyPage(() => import("./MembresiaTelegram"));
export const Modelo = lazyPage(() => import("./Modelo"));
export const Nude = lazyPage(() => import("./Nude"));
export const Nutricion = lazyPage(() => import("./Nutricion"));
export const Onlyfans = lazyPage(() => import("./Onlyfans"));
export const Pack = lazyPage(() => import("./Pack"));
export const Personalidad = lazyPage(() => import("./Personalidad"));
export const Photography = lazyPage(() => import("./Photography"));
export const Pornhub = lazyPage(() => import("./Pornhub"));
export const Premium = lazyPage(() => import("./Premium"));
export const Privado = lazyPage(() => import("./Privado"));
export const Recetas = lazyPage(() => import("./Recetas"));
export const Reels = lazyPage(() => import("./Reels"));
export const ReelSecretShare = lazyPage(() => import("./ReelSecretShare"));
export const Pack1 = lazyPage(() => import("./Pack1"));
export const Pack2 = lazyPage(() => import("./Pack2"));
export const Pack3 = lazyPage(() => import("./Pack3"));
export const SubscripcionesPlanes = lazyPage(() => import("./dashboard/SubscripcionesPlanes"));
export const EnvSetup = lazyPage(() => import("./dashboard/EnvSetup"));
export const DualCtaFunnelDashboard = lazyPage(() => import("./dashboard/DualCtaFunnelDashboard"));
export const GiftProduct = lazyPage(() => import("./GiftProduct"));
export const ProductPageSimple = lazyPage(() => import("./ProductPageSimple"));
export const DirectCheckout = lazyPage(() => import("./DirectCheckout"));
export const ProductReel = lazyPage(() => import("./ProductReel"));
export const ProductReelMockTest = lazyPage(() => import("./ProductReelMockTest"));
export const ProductPageMockUsd = lazyPage(() => import("./ProductPageMockUsd"));
export const ProductPageMockArs = lazyPage(() => import("./ProductPageMockArs"));
export const Rutina = lazyPage(() => import("./Rutina"));
export const Skincare = lazyPage(() => import("./Skincare"));
export const SocialMedia = lazyPage(() => import("./SocialMedia"));
export const TestMuxCountry = lazyPage(() => import("./TestMuxCountry"));
export const TestCheckout = lazyPage(() => import("./TestCheckout"));
export const DualCTAVideoLanding = lazyPage(() => import("./DualCTAVideoLanding"));
export const FullscreenExclusive = lazyPage(() => import("./FullscreenExclusive"));
export const FullscreenSorpresa = lazyPage(() => import("./FullscreenSorpresa"));
export const Sorprendeme = lazyPage(() => import("./Sorprendeme"));
export const VipCustomPayment = lazyPage(() => import("./VipCustomPayment"));
export const TestExclusivo = lazyPage(() => import("./TestExclusivo"));
export const BestFriendInstagram = lazyPage(() => import("./BestFriendInstagram"));
export const BestFriendInstagramSuccess = lazyPage(() => import("./BestFriendInstagramSuccess"));
export const WhatsAppBroadcast = lazyPage(() => import("./WhatsAppBroadcast"));
export const InstagramMejoresAmigos = lazyPage(() => import("./InstagramMejoresAmigos"));
export const TestPage = lazyPage(() => import("./TestPage"));
export const StripeValidation = lazyPage(() => import("./StripeValidation"));
export const TikTok = lazyPage(() => import("./TikTok"));
export const Tiktoker = lazyPage(() => import("./Tiktoker"));
export const TravelInfluencer = lazyPage(() => import("./TravelInfluencer"));
export const Viajes = lazyPage(() => import("./Viajes"));
export const Video = lazyPage(() => import("./Video"));
export const VideosDesnuda = lazyPage(() => import("./VideosDesnuda"));
export const VideosGratis = lazyPage(() => import("./VideosGratis"));
export const Wellness = lazyPage(() => import("./Wellness"));
export const Xvideos = lazyPage(() => import("./Xvideos"));
export const YouTube = lazyPage(() => import("./YouTube"));
export const TerminosYCondiciones = lazyPage(() => import("./TerminosYCondiciones"));
export const PrivacyPolicy = lazyPage(() => import("./PrivacyPolicy"));
export const CookiePolicy = lazyPage(() => import("./CookiePolicy"));
export const DarDeBaja = lazyPage(() => import("./DarDeBaja"));
export const Portfolio = lazyPage(() => import("./Portfolio"));
export const MediaKitIntro = lazyPage(() => import("./MediaKitIntro"));
export const MediaKitDesktop = lazyPage(() => import("./MediaKitDesktop"));
export const Audiovisual = lazyPage(() => import("./Audiovisual"));
export const TestBaseTemplate = lazyPage(() => import("./TestBaseTemplate"));
export const TestCTAButtons = lazyPage(() => import("./TestCTAButtons"));

const LazyCountryLanding = lazy(() => import("./CountryLanding"));

/** SEO country landings share one chunk; slug passed per route. */
export function CountryLandingPage({ slug }: { slug: string }) {
  const Page = LazyCountryLanding as ComponentType<{ slug: string }>;
  return (
    <Suspense fallback={<TemplateLoadingScreen />}>
      <Page slug={slug} />
    </Suspense>
  );
}
